import { useEffect } from 'react'
import { useAppDispatch } from 'state'
import { useSelector } from "react-redux";
import { State } from "./types";
import { LocalStoragePersistanceService } from "persist/LocalStorage";
import { setUserData } from "./users";

const localStore = new LocalStoragePersistanceService();

export const useFetchPublicData = () => {
  const dispatch = useAppDispatch()
  useEffect(() => {

    const user = localStore.getItem("user");
    const jwt = localStore.getItem("jwt");
    
    if (user && jwt) {
      dispatch(setUserData({ user, jwt }));
    }
  }, [dispatch])
}; // End of use Fetch Public Data

// User
export const useUser = () => {
  return useSelector((state: State) => state.user);
};

export const useJWT = () => {
  return useSelector((state: State) => state.user.jwt);
};

export const useSearchValue = () => {
  return useSelector((state: State) => state.user.searchInput);
};


